<template>
  <v-layout wrap>
    <time-picker
        :id="id"
        :title="pickerTitle"
        :model-value="timeValue"
        :min-time="minTime"
        :max-time="maxTime ? maxTime : '23:59'"
        :clearable="clearable"
        :rules="rules"
        @update:model-value="value => sendTimeValue(value)"
    >
    </time-picker>
  </v-layout>
</template>

<script setup>
import {ref} from "vue";
import TimePicker from "@/components/time-picker/TimePicker.vue";

const props = defineProps({
  id: String,
  neighborId: String,
  rules: Array,
  initialValue: String,
  title: String,
  minTime: String,
  maxTime: String,
  clearable: Boolean,
  prependIcon: Boolean,
  condensed: Boolean,
  disabled: Boolean
})

const emit = defineEmits(['timeChanged','trySubmit'])

const timeValue = ref(props.initialValue ? props.initialValue : undefined)
const pickerTitle = ref(props.title ? props.title : 'Čas')

function sendTimeValue(value){
  emit('timeChanged', value)
}

function reset() {
  timeValue.value = undefined
  emit('timeChanged', timeValue.value)
}

defineExpose({
  reset
})
</script>